export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '96908400-e1c3-4080-a2c0-3d48ee42d0fc';
export const MODAL_CLOSE_SEC = 2.5;
